module.exports = __webpack_public_path__ + "static/media/cctv_surveillance.f427b043.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/cctv_surveillance.svg
// module id = 1512
// module chunks = 0